module.exports = __webpack_public_path__ + "img/ai.9e61b1f7.webp";